/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  Avatar,
  Button,
  FormLabel,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import classes from "./UserInformation.module.css";
import editLogo from "../../images/DefaultProfilePic.png";
import { ConfigurationVariables } from "../../config";
import axios from "../../utils/axios-instance/AxiosInstance";
import DeleteDialog from "../SharedComponents/DeleteDialog";
import SuccessDialog from "../SharedComponents/SuccessDialog";
import { AppDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { deleteTenantUser } from "../../store/User/user-actions";
import Loader from "../Loader/Loader";
import { IErrorProps } from "../../models";
import ToastBarForError from "../SharedComponents/ToastBarForError";
import UserPermissions from "../../models/apiModels/UserPermissions";
import UserDisplayDetails from "../../utils/UserInfo/UserInfoBox";
import { getAccessToken } from "../../utils";

function UserInformationPage(props: any) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [userLogo, setUserLogo] = useState<string>("");
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  const [userSelected, setUserSelected] = useState<{
    customerId: string;
    userIds: Array<string>;
  }>({
    customerId: "",
    userIds: [""],
  });

  const userId = location.state.UserInfo.id;
  const firstName = location.state.UserInfo.firstName;
  const lastName = location.state.UserInfo.lastName;
  const emailId = location.state.UserInfo.emailId;
  const [errorList, setErrorList] = useState<IErrorProps[]>([]);
  const [openToastError, setOpenToastError] = useState(false);
  const assignedRoles: string[] = location.state.UserInfo.roles
    ? location.state.UserInfo.roles
        .map((x: { name: any }) => x.name)
        .join(",")
        .toString()
    : [];
  const forgeCustomerId = location.state.CustomerId;
  const backButtonHandler = () => {
    navigate("/tenant/user", { state: location.state.CustomerDetails });
  };
  const { UserMgmt_Endpoints, Api, Version, UserController } =
    ConfigurationVariables;
  let usersUrl = `${UserMgmt_Endpoints}/${Api}/${Version}/${UserController}`;
  const headers = {
    customerId: forgeCustomerId,
    accept: "application/json",
    Authorization: `Bearer ${getAccessToken()}`,
  };

  const userPermissions: UserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );
  useEffect(() => {
    let getUserLogo = `${usersUrl}/userpic/${userId}`;
    setLoading(true);
    axios
      .get(getUserLogo, {
        headers: {
          ...headers,
        },
      })
      .then((response) => {
        setUserLogo(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setErrorModal(true);
        setErrorMsg(error?.message);
        let errorObj = {
          errorCode: error?.response?.status,
          errorMessage: error?.message,
        };
        setErrorList((prevList) => [...prevList, errorObj]);
        setOpenToastError(true);
      });
  }, []);

  function handleEdit() {
    if (userPermissions.can_update_user) {
      const userDetailsToEdit = {
        CustomerId: location.state.CustomerId,
        UserInfo: location.state.UserInfo,
      };
      navigate(`/tenant/user/edit`, {
        state: { userDetailsToEdit },
      });
    } else {
      //for error list
      // istanbul ignore next
      setForBiddenError(403, "User doesn't have privileges to Edit the Users");
    }
  }

  function handleDelete() {
    if (userPermissions.can_delete_user) {
      setUserSelected({
        userIds: [userId],
        customerId: forgeCustomerId,
      });
      setOpenDeleteDialog(true);
    } else {
      //for error list
      // istanbul ignore next
      setForBiddenError(
        403,
        "User doesn't have privileges to Delete the Users"
      );
    }
  }
  //on click of stoast for delete
  // istanbul ignore next
  const handleClose = () => {
    setUserSelected({
      customerId: "",
      userIds: [""],
    });
    setOpenDeleteDialog(false);
  };
  //on click of stoast for delete
  // istanbul ignore next

  const handleDeleteConfirmation = () => {
    setOpenDeleteDialog(false);
    dispatch(deleteTenantUser(userSelected))
      .then(() => {
        setUserSelected({
          userIds: [""],
          customerId: "",
        });
        setSuccessDialogOpen(true);
      })
      .catch((err: any) => {});
  };
  //on close of successDialogOpen
  // istanbul ignore next

  const handleSuccesssConfirmationClose = () => {
    setSuccessDialogOpen(false);
    navigate("/tenant/user", { state: location.state.CustomerDetails });
  };

  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  return (
    <>
      <Paper className="paper">
        <Grid container direction="row" p={1} className="grid-Heading">
          <Grid
            item
            xs={12}
            sx={{ paddingBottom: 1, display: "flex", flexDirection: "row" }}
          >
            <Button
              data-testid="arrow-back-icon"
              onClick={backButtonHandler}
              sx={{
                color: "#F0F0F0",
                padding: "0vh 0vh 0.7vh 0vh",
                fontSize: "1.1 rem",
                justifyContent: "start",
                minWidth: "1vw",
                minHeight: "0.5vh",
              }}
            >
              <ArrowBackIosIcon sx={{ fontSize: "0.9 rem" }} />
            </Button>

            <Typography className={classes.mainheading}>
              User Information
            </Typography>
          </Grid>
          <Grid
            container
            direction="column"
            sx={{
              paddingTop: "2vh",
              height: "32vh",
              minWidth: "850px",
              minHeight: "180px",
              width: "99%",
              background: "#272727",
              border: "1px solid #101010",
              boxShadow:
                "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
            }}
          >
            <Grid
              item
              sx={{
                width: "20%",
                height: "100%",
                minHeight: "150px",
                minWidth: "150px",
              }}
              data-testid="profile-pic"
            >
              {userLogo === "" ? (
                <Avatar
                  sx={{
                    height: "22vh",
                    width: "22vh",
                    minHeight: "120px",
                    minWidth: "120px",
                    position: "flex",
                    margin: "10%",
                  }}
                  alt="Upload Logo"
                  src={editLogo}
                />
              ) : (
                <Avatar
                  sx={{
                    height: "22vh",
                    width: "22vh",
                    minHeight: "120px",
                    minWidth: "120px",
                    position: "flex",
                    margin: "10%",
                  }}
                  alt="Upload Logo"
                  src={`data:image/jpeg;base64,${userLogo}`}
                />
              )}
            </Grid>
            <Grid
              container
              direction="row"
              sx={{
                width: "80%",
                height: "100%",
                minWidth: "600px",
                minHeight: "180px",
              }}
            >
              <Grid
                item
                sx={{
                  height: "10%",
                  width: "100%",
                }}
              >
                <Typography className={classes.secondaryHeading}>
                  BASIC INFORMATION
                </Typography>
              </Grid>

              <Grid
                container
                direction="row"
                sx={{ height: "40%", width: "100%" }}
              >
                <Grid item sx={{ width: "50%" }}>
                  <UserDisplayDetails label={"First Name"} detail={firstName} />
                </Grid>
                <Grid item sx={{ width: "50%" }}>
                  <UserDisplayDetails label={"Last Name"} detail={lastName} />
                </Grid>
              </Grid>

              <Grid item sx={{ height: "10%", width: "100%" }}>
                <Typography className={classes.secondaryHeading}>
                  OTHER INFORMATION
                </Typography>
              </Grid>

              <Grid
                container
                direction="row"
                sx={{ height: "40%", width: "100%" }}
              >
                <Grid item sx={{ width: "50%" }}>
                  <UserDisplayDetails label={"Email ID"} detail={emailId} />
                </Grid>
                <Grid item sx={{ width: "50%" }}>
                  <Grid
                    container
                    direction="column"
                    sx={{ padding: "1vh" }}
                    xs={12}
                    md={12}
                    xl={12}
                  >
                    {" "}
                    <FormLabel className={classes.labelHeading}>
                      Assigned Roles
                    </FormLabel>
                    <FormLabel
                      sx={{ paddingTop: "0.5vh", width: "100%" }}
                      className={classes.labelValue}
                    >
                      {assignedRoles}
                    </FormLabel>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/*  */}
        <Grid
          item
          xs={12}
          sx={{
            backgroundColor: "#272727",
            width: "98%",
            border: "1px solid #101010",
            boxShadow:
              "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
            display: "flex",
            position: "fixed",
            bottom: 1,
            height: "8vh",
          }}
        >
          <Grid sx={{ height: "3vh", padding: "0.5vh" }}>
            <Button
              color="primary"
              fullWidth
              sx={{
                height: "1vh",
                margin: "1vw",
                position: "relative",
              }}
              onClick={() => {
                handleDelete();
              }}
              className={classes.deleteButton}
            >
              Delete
            </Button>
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            sx={{ height: "3vh", paddingRight: "1.5vw", margin: "0.5vh" }}
          >
            <Button
              sx={{
                padding: 2,
                height: "1vh",
                position: "relative",
                margin: "0.5vw",
              }}
              onClick={() => {
                handleEdit();
              }}
              variant="contained"
              className={classes.editUser}
            >
              Edit{" "}
            </Button>
          </Grid>
        </Grid>
        {/*  */}

        {/* <Grid container direction="row" paddingLeft={1.5} paddingRight={1.5} bottom={0}
                    item
                    p={2}
                    className={classes.cancelcreatebtnsbox}
                    sx={{
                        width: "100%",
                        background: "#272727",
                        border: "1px solid #101010",
                        boxShadow:
                            "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
                        padding: 1
                    }}

                >
                    <Grid
                        container
                        justifyContent="flex-start"
                        sx={{ height: "50px", padding: "10px" }}
                    >
                        <Button
                            sx={{
                                fontSize: 10,
                                padding: 2,
                                height: "10px",
                                position: "relative",
                            }}
                            variant="text"
                            color="primary"
                            onClick={() => {
                                handleDelete();
                            }}
                        >
                            Delete
                        </Button>
                    </Grid>
                    {/* <Grid
                        container direction='column'
                        sx={{ height: "50px", padding: "10px" }}
                    > */}
        {/* <Grid
                        container
                        justifyContent="flex-end"
                        sx={{ height: "50px", padding: "10px" }}
                    >
                        <Button
                            sx={{
                                fontSize: 9,
                                padding: 2,
                                height: "10px",
                                position: "relative",
                                justifyContent: "flex-end",
                                width: '3vw'

                            }}

                            variant="contained"
                            className={classes.editUser}
                            onClick={() => {
                                handleEdit();
                            }}
                        >
                            Edit
                        </Button>
                    </Grid>

                </Grid>  */}
      </Paper>
      {openDeleteDialog && (
        <DeleteDialog
          open={openDeleteDialog}
          title="Delete User"
          handleClose={handleClose}
          DeleteConfirmationMessage={"Do you want to delete the user?"}
          handleDeleteConfirmation={handleDeleteConfirmation}
        />
      )}
      {successDialogOpen && (
        <SuccessDialog
          open={successDialogOpen}
          title="Successfully Deleted"
          SucessConfirmationMessage="Successfully deleted user"
          handleClose={handleSuccesssConfirmationClose}
        />
      )}
      {loading && <Loader />}
      {errorList?.length > 0 && (
        <ToastBarForError
          open={openToastError}
          onClose={handleToastBarClose}
          errorList={errorList}
        />
      )}
    </>
  );

  //for error list
  // istanbul ignore next

  function setForBiddenError(errorCode: number, message: string) {
    const error: IErrorProps = {
      errorCode: errorCode,
      errorMessage: message,
    };
    const errorList: IErrorProps[] = [];
    errorList.push(error);
    setErrorList(errorList);
    setOpenToastError(true);
  }
}

export default UserInformationPage;
